module.exports = __webpack_public_path__ + "static/media/services.db6e867b.jpg";